import { ReactNode, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import styles from "./AccordionComponent.module.scss";

export interface AccordionComponentProps {
  title: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

let accordionSequence = 0;

const AccordionComponent = ({ title, children, defaultOpen = false, className = "" }: AccordionComponentProps): JSX.Element => {
  const [open, setOpen] = useState(defaultOpen);
  const [panelId] = useState(() => `accordion-panel-${++accordionSequence}`);

  return (
    <section className={`${styles.root} ${className}`}>
      <button
        type="button"
        className={styles.trigger}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((current) => !current)}
      >
        <span>{title}</span>
        <FiChevronDown className={open ? styles.open : ""} aria-hidden="true" />
      </button>
      {open ? <div id={panelId} className={styles.panel}>{children}</div> : null}
    </section>
  );
};

export default AccordionComponent;
